{
  "app_name": "金数据客户端 UAT",
  "ios": {
    "CFBundleDisplayName": "金数据 UAT"
  }
}
